import { ApiProperty } from "@nestjs/swagger";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { EmployeeExperienceDetails } from "../employee-details/employee-experience-details.entity";
import { EmployeeIdProofDetails } from "../employee-details/employee-id-proof-details.entity";
import { Product } from "../products/product.entity";
import { PackingMethod } from "../packing-mathods/packing-methods.entity";
import { PackingCategoryEnum } from "@gtpl/shared-models/common-models";
import { FgPriceListCategoryEnum } from "@gtpl/shared-models/masters";
import { FgpriceList } from "./fg-pricelist-entity";

@Entity('product_price_list_logs')
export class FgpriceListLogs{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    
    @Column({
      type:"decimal",precision:10,scale:2,
      nullable: false,
      name: "min_price"
    })
    minPrice: number;
    
    @Column({
      type:"decimal",precision:10,scale:2,
      nullable: false,
      name: "mid_price"
    })
    midPrice: number;
    
    @Column({
      type:"decimal",precision:10,scale:2,
      nullable: false,
      name: "high_price"
    })
   highPrice: number;
     
   
  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @Column({
    name: "effective_from",
    type: 'datetime'
  })
  effectiveFrom: Date;

 
  // @Column("enum", {
  //   nullable: false,
  //   name: "category",
  //   enum:FgPriceListCategoryEnum
  // })
  // category: FgPriceListCategoryEnum;

  // @Column('int',{
  //   nullable: true,
  //   name: "fg_pricelist_id"
  // })
  // FgpriceListId: number;
   

  // @ManyToOne(type=>Product, e=>e.fgPriceInfo,{  nullable:false, })
  //   @JoinColumn({ name:"product_id"})
  //   productId: Product;

    @ManyToOne(type=>FgpriceList, e=>e.fgPriceInfo,{ nullable:false, })
    @JoinColumn({ name:"fg_pricelist_id"})
    FgpriceListId: FgpriceList;

}